import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { openNotification } from 'src/components/helpers/notification';
import ax from 'src/store/config';


const initialState = {
    paymentsList: null,
    paymentsListLoading: false
};

export const paymentsAction = createAsyncThunk('paymentsAction', async (payload, { dispatch }) => {
    dispatch(setPaymentsListLoading(true))
    try {
        let data;
        const url = '/api/admin/directory/payments';
        switch (payload.flag) {
            case 'get':
                ({ data } = await ax.get(url, { params: payload.value }))
                data && dispatch(setPaymentsListLoading(false))
                return data

            case 'post':
                ({ data } = await ax.post(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Оплата успешно отредактирована`
                })
                break;

            case 'put':
                ({ data } = await ax.put(url, payload.value))
                data && openNotification({
                    type: 'success',
                    message: `Оплата успешно добавлена`
                })
                break;

            case 'delete':
                ({ data } = await ax.delete(url, { params: payload.value }))
                data && openNotification({
                    type: 'success',
                    message: `Оплата успешно удалена`
                })
                break;

            default:
                break;
        }
    } catch (error) {
        dispatch(setPaymentsListLoading(false))
        openNotification({
            type: 'error',
            message: `Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`
        })
        return error
    }
})

const PaymentsSlice = createSlice({
    name: 'payments',
    initialState,
    reducers: {
        setPaymentsListLoading: (state, action) => {
            state.paymentsListLoading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(paymentsAction.fulfilled, (state, action) => {
            state.paymentsList = action.payload
        })
    }
});

export const { setPaymentsListLoading } = PaymentsSlice.actions;

export default PaymentsSlice.reducer